import { useSelector } from 'react-redux';

export const useLoginFields = () => {
    return useSelector(({ login }) => login);
};
